import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    A11y
} from 'swiper/modules';

document.querySelectorAll('.swiperFullwidthSlider').forEach(function (thisSlider) {
    const container = thisSlider.closest('.swiperFullwidthBlock');
    const nextButton = container.querySelector('.swiperFullwidthNext');
    const prevButton = container.querySelector('.swiperFullwidthPrev');

    new Swiper(thisSlider, {
        modules: [Navigation, Pagination, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
        },
    });
});

document.querySelectorAll('.swiperNewsSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperNewsBlock');
    const nextButton = container.querySelector('.swiperNewsNext');
    const prevButton = container.querySelector('.swiperNewsPrev');

    new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },  
        slidesPerView: "auto",
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 12,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: "auto",
                spaceBetween: 16,
            },
            1200: {
                spaceBetween: 16,
            },
        },
    });
});


document.querySelectorAll('.swiperEventsSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperEventsBlock');
    const nextButton = container.querySelector('.swiperEventsNext');
    const prevButton = container.querySelector('.swiperEventsPrev');

    new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },  
        slidesPerView: "auto",
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 12,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: "auto",
                spaceBetween: 16,
            },
            1200: {
                spaceBetween: 16,
            },
        },
    });
});


document.querySelectorAll('.swiperSignpostSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperSignpostBlock');
    const nextButton = container.querySelector('.swiperNewsNext');
    const prevButton = container.querySelector('.swiperNewsPrev');

    new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },  
        slidesPerView: "auto",
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                enabled: true,
                slidesPerView: 1.5,
                spaceBetween: 12,
            },
            576: {
                enabled: true,
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            992: {
                enabled: true,
                slidesPerView: 2.75,
                spaceBetween: 16,
            },
            1200: {
                enabled: false,
                spaceBetween: 0,
                slidesPerView: "auto",
            },
        },
    });
});

document.querySelectorAll('.swiperOverflowSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperOverflowBlock');
    const nextButton = container.querySelector('.swiperOverflowNext');
    const prevButton = container.querySelector('.swiperOverflowPrev');

    new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1400: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
});

document.querySelectorAll('.swiperImageGallerySlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperImageGalleryBlock');
    const nextButton = container.querySelector('.swiperCenteredNext');
    const prevButton = container.querySelector('.swiperCenteredPrev');

    new Swiper(slider, {
        modules: [Navigation, A11y, Pagination],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            1400: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
        },
    });
});


document.querySelectorAll('.swiperTestimonialSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperTestimonialBlock');
    const nextButton = container.querySelector('.swiperTestNext');
    const prevButton = container.querySelector('.swiperTestPrev');

    new Swiper(slider, {
        modules: [Navigation, A11y, Pagination],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 2.5,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 2.5,
                spaceBetween: 16,
            },
            1400: {
                slidesPerView: 3.2,
                spaceBetween: 16,
            },
        },
    });
});